import React, { useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useAddEmployeePAN } from "../../../queries/employeeQueries";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { panRegex, fullNameRegex } from "../../../utils/regex/regex";
const EditOrAddPan = ({ openModal, onCloseModal, employee, panDetails }) => {
  const { mutate: addOrEditEmployeePAN, isLoading } = useAddEmployeePAN();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name_on_pan: panDetails?.name_on_pan || "",
      pan_number: panDetails?.pan_number || "",
    },
  });
  useEffect(() => {
    if (panDetails) {
      reset({
        name_on_pan: panDetails.name_on_pan || "",
        pan_number: panDetails.pan_number || "",
      });
    }
  }, [panDetails]);

  const onSubmit = (data) => {
    const requestData = {
      employee_id: employee?.employee_id,
      pan_number: data?.pan_number,
      name_on_pan: data?.name_on_pan,
    };

    addOrEditEmployeePAN(requestData, {
      onSuccess: (response) => {
        response = response?.data || {};
        const message = response?.message || "PAN details added successfully";
        toast.success(message);
        onCloseModal();
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Failed to add PAN details.";
        toast.error(message);
      },
    });
  };

  return (
    <Modal open={openModal} onClose={onCloseModal} center>
      <div className="p-5 w-[380px]">
        <h2 className="text-lg leading-6 text-[#1F2937] font-semibold mb-5">
          Edit/Add PAN
        </h2>
        <form
          key={panDetails?.pan_number}
          className="flex flex-col gap-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="w-[332px]">
            <label className="text-sm font-medium text-black">
              Name in PAN <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              {...register("name_on_pan", {
                required: "Name is required",
                pattern: {
                  value: fullNameRegex,
                  message:
                    "Numbers , Special Characters and Space are not allowed!",
                },
              })}
              className="h-[38px] w-full border rounded px-2"
            />
            {errors.name_on_pan && (
              <p className="text-sm text-red-600 mt-1">
                {errors.name_on_pan.message}
              </p>
            )}
          </div>

          <div className="w-[332px]">
            <label className="text-sm font-medium text-black">
              PAN Number <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              {...register("pan_number", {
                required: "PAN number is required",
                pattern: {
                  value: panRegex,
                  message:
                    "Format: 5 letters, 4 digits, 1 letter (e.g., ABCDE1234F)",
                },
              })}
              className="h-[38px] w-full border rounded px-2 uppercase"
            />
            {errors.pan_number && (
              <p className="text-sm text-red-600 mt-1">
                {errors.pan_number.message}
              </p>
            )}
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              className="btn btn--border text-sm font-medium"
              onClick={onCloseModal}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn text-sm font-medium"
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EditOrAddPan;
